import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API_KEY } from "../service/requests";
import Loadingspinner from "../components/Loadingspinner";
import SimpleBar from "simplebar-react";

function DetailFilm() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [filmDetails, setFilmDetails] = useState([]);
  const [filmCredits, setCredits] = useState([]);

  let { id } = useParams();

  const fetchUrl = `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&language=de-DE`;
  const fetchUrl2 = `https://api.themoviedb.org/3/movie/${id}/credits?api_key=${API_KEY}&language=de-DE`;

  useEffect(() => {
    Promise.all([
      fetch(fetchUrl).then((value) => value.json()),
      fetch(fetchUrl2).then((value) => value.json()),
    ]).then((response) => {
      setFilmDetails(response[0]);
      setCredits(response[1]);
      setIsLoaded(true);
    });
  }, [fetchUrl, fetchUrl2]);

  const image_url = "https://image.tmdb.org/t/p/w500";
  const release = new Date(
    filmDetails?.release_date || filmDetails?.first_air_date
  );
  const options = { year: "numeric", month: "long", day: "numeric" };

  return (
    <section className="details">
      <div className="container">
        <div className="row">
          {isLoaded ? (
            <>
              <div className="col-md-4">
                {filmDetails?.backdrop_path === null ? (
                  <img
                    src="https://via.placeholder.com/500"
                    alt="Placeholder"
                  />
                ) : (
                  <img
                    src={`${image_url}${
                      filmDetails?.poster_path || filmDetails?.backdrop_path
                    }`}
                    alt={filmDetails.name}
                  />
                )}
                {filmDetails.genres.length === 0 ? (
                  <></>
                ) : (
                  <>
                    <h4 className="blue">Genres</h4>
                    <ul className="genres">
                      {filmDetails.genres.map((genre, index) => (
                        <li key={index}>{genre.name}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>

              <div className="col-md-8">
                <h4 className="name">
                  {filmDetails?.title ||
                    filmDetails?.name ||
                    filmDetails?.original_name}
                </h4>
                <ul className="movie-details">
                  <li>
                    <i className="fas fa-star"></i> {filmDetails?.vote_average}
                  </li>
                  <li>
                    <i className="fas fa-heart"></i> {filmDetails?.vote_count}
                  </li>
                  <li>
                    <i className="fas fa-calendar-alt"></i>{" "}
                    <span className="stage__release">
                      {release.toLocaleDateString("de-DE", options)}
                    </span>
                  </li>
                  <li>Dauer: {filmDetails?.runtime} min</li>
                </ul>
                <h4>Handlung</h4>
                {filmDetails.overview === "" ? (
                  <p>Leider kein Text vorhanden.</p>
                ) : (
                  <p>{filmDetails.overview}</p>
                )}
                <h4>Produktionsfirmen</h4>
                {filmDetails.overview === "" ? (
                  <p>Leider kein Text vorhanden.</p>
                ) : (
                  <ul className="firm">
                    {filmDetails.production_companies.map((firm, index) => (
                      <li key={index}>{firm.name}</li>
                    ))}
                  </ul>
                )}
                <h4>Cast</h4>
                {filmCredits.cast.length === 0 ? (
                  <p>Leider keine Daten vorhanden.</p>
                ) : (
                  <div className="cast-wrapper">
                    <SimpleBar>
                      <ul className="cast">
                        {filmCredits.cast.map((cast, index) => (
                          <li key={index}>
                            <Link to={`/personen/${cast.id}`}>
                              <div className="cast__img">
                                {cast?.profile_path === null ? (
                                  <img
                                    src="https://via.placeholder.com/500x750"
                                    alt="Placeholder"
                                  />
                                ) : (
                                  <img
                                    src={`${image_url}${cast?.profile_path}`}
                                    alt={cast.name}
                                  />
                                )}
                              </div>
                              <div className="cast__name">
                                {cast?.title ||
                                  cast?.name ||
                                  cast?.original_name}
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </SimpleBar>
                  </div>
                )}
              </div>
            </>
          ) : (
            <Loadingspinner />
          )}
        </div>
      </div>
    </section>
  );
}

export default DetailFilm;
